import { useState, useEffect } from 'react';
import { fetchAdminUsers, updateAdminUser } from '../../services/api';

const SUPPORT_LABELS = {
  beginner: 'Začátečník',
  independent: 'Samostatně',
};

const UsersManager = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(null); // userId being saved

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchAdminUsers();
        setUsers(data);
      } catch (err) {
        setError('Nepodařilo se načíst uživatele.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleSupportLevelChange = async (userId, newLevel) => {
    setSaving(userId);
    try {
      const updated = await updateAdminUser(userId, { support_level: newLevel });
      setUsers(prev => prev.map(u => u.id === userId ? { ...u, support_level: updated.support_level } : u));
    } catch (err) {
      alert('Nepodařilo se uložit změnu.');
    } finally {
      setSaving(null);
    }
  };

  if (loading) return <p style={{ color: '#666', padding: '20px' }}>Načítám uživatele...</p>;
  if (error) return <p style={{ color: '#dc3545', padding: '20px' }}>{error}</p>;

  return (
    <div>
      <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '16px', color: '#1f2937' }}>
        Správa uživatelů
      </h2>
      <div style={{ borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
          <thead>
            <tr style={{ textAlign: 'left', backgroundColor: '#f9fafb' }}>
              <th style={{ padding: '12px 16px', color: '#6b7280', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '2px solid #e5e7eb' }}>Uživatel</th>
              <th style={{ padding: '12px 16px', color: '#6b7280', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '2px solid #e5e7eb' }}>E-mail</th>
              <th style={{ padding: '12px 16px', color: '#6b7280', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '2px solid #e5e7eb' }}>Role</th>
              <th style={{ padding: '12px 16px', color: '#6b7280', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '2px solid #e5e7eb' }}>Úroveň podpory</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u, index) => (
              <tr key={u.id} style={{ borderBottom: '1px solid #e5e7eb', backgroundColor: index % 2 === 0 ? '#fff' : '#f9fafb', transition: 'background-color 0.15s ease' }}>
                <td style={{ padding: '12px 16px', fontWeight: 500 }}>{u.username}</td>
                <td style={{ padding: '12px 16px', color: '#666' }}>{u.email}</td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{
                    display: 'inline-block',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    fontSize: '0.78rem',
                    fontWeight: 600,
                    background: u.is_admin ? '#fce8d5' : '#e8f4fd',
                    color: u.is_admin ? '#c0440a' : '#1a73e8',
                  }}>
                    {u.is_admin ? 'Admin' : 'Student'}
                  </span>
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <select
                    value={u.support_level || 'beginner'}
                    disabled={saving === u.id}
                    onChange={e => handleSupportLevelChange(u.id, e.target.value)}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '6px',
                      border: '1.5px solid #e5e7eb',
                      fontSize: '0.88rem',
                      cursor: saving === u.id ? 'wait' : 'pointer',
                      background: saving === u.id ? '#f9fafb' : 'white',
                      transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
                      outline: 'none',
                    }}
                    onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.15)'; }}
                    onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
                  >
                    {Object.entries(SUPPORT_LABELS).map(([value, label]) => (
                      <option key={value} value={value}>{label}</option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersManager;
